import { render } from "./AdminCoupons.vue?vue&type=template&id=788beb8c&scoped=true"
import script from "./AdminCoupons.vue?vue&type=script&lang=js"
export * from "./AdminCoupons.vue?vue&type=script&lang=js"

import "./AdminCoupons.vue?vue&type=style&index=0&id=788beb8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-788beb8c"]])

export default __exports__